export const UomIsoCodes = {
  tons: 'STN',
  pounds: 'LBR',
};
